module.exports = __webpack_public_path__ + "static/img/obramowanie.0b547cf2.png";